module.exports = __webpack_public_path__ + "img/quest_scored_field.54a41dd0.svg";